import { GeneralArrowRightIcon } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Link from '@/components/switchback/Link/Link';
import { useRouter } from '@/hooks/useRouter';

import styles from './LYRVBanner.module.css';

const LYRVBanner = () => {
  const router = useRouter();
  const intl = useIntl();
  const handleOnClick = () => {
    router.push('/list-your-rv?cam=864&utm_campaign=blog_internal');
  };

  return (
    <button className={`${styles.Banner} w-full sm:py-9 cursor-pointer`} onClick={handleOnClick}>
      <div className="flex flex-row mx-4 highlight md:mx-12 lg:mx-28 xxxl:mx-auto max-w-xxl">
        <div className="flex items-center justify-start w-1/2 sm:w-7/12 lg:w-9/12 xl:7/12">
          <div className="flex flex-col py-6 text-left text-white sm:py-0 sm:pl-0">
            <h3 className="text-base h3 md:text-2xl lg:mb-2">
              <FormattedMessage
                defaultMessage="Earn over $50,000 per year by listing your RV."
                id="LzRrJF"
              />
            </h3>
            <p className={`font-normal text-base" ${styles.BannerText}`}>
              {intl.formatMessage({ defaultMessage: 'Industry leading insurance', id: 'oOeSsL' })}
              <span className="mx-2">|</span>
              {intl.formatMessage({ defaultMessage: 'Customer Support 24/7 ', id: 'zPW0wb' })}
              <span className="mx-2">|</span>
              {intl.formatMessage({ defaultMessage: 'Make more money ', id: 'nATwqf' })}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-end w-1/2 text-base tracking-wide md:text-lg highlight sm:w-5/12 lg:w-3/12 xl:w-5/12 xl:pr-4">
          <Link className={styles.Link} href="/list-your-rv?cam=864&utm_campaign=blog_internal">
            <FormattedMessage defaultMessage="Get started" id="/aBLH2" />
            <GeneralArrowRightIcon fontSize={24} />
          </Link>
        </div>
      </div>
    </button>
  );
};

export default LYRVBanner;
